



























































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {DateTime} from 'luxon';
import {axiosInstance, CALENDAR_FORMAT, getStoreSettings, nil} from '@/common';
import PagedTable from '@/components/Views/Dashboard/PagedTable.vue';
import draggable from 'vuedraggable';
import {Mixins} from 'vue-property-decorator';
import UserRoleMixin from '@/mixins/UserRoleMixin.vue';
import axios from 'axios';
import {parseify} from '@/common';
import {FeathersVuexFindAll} from '@/utils';
import {debounce} from 'lodash';
import TimePicker from "@/components/Views/UI/TimePicker.vue";

@Component({
    components: {TimePicker, PagedTable, draggable},
})
export default class DashboardSettings extends Mixins(UserRoleMixin) {

    get maxBookTimeHint(): string {
        try {
            let dt = DateTime.fromFormat('8', 'H');
            dt = dt.plus({hours: this.setting.maxBookTime});
            return `Example: at 8AM, your booking must be at least ${dt.toFormat('h a')} or later`;
        } catch (e) {
            return '';
        }
    }

    get maxBookAdvanceHint(): string {
        try {
            let now = DateTime.local();
            now = now.plus({days: this.setting.maxBookAdvanceDays});
            return `Example: If booking today, you can book up till ${now.toFormat('MM/dd/yyyy')}`;
        } catch (e) {
            return '';
        }
    }

    public get vendorBreakBetweenBookingHint(): string {
        try {
            let dt = DateTime.fromFormat('10', 'H');
            dt = dt.plus({hours: this.setting.vendorBreakBetweenBooking});
            return `Example: If a pro completes a booking at 10AM, they will not be alerted or scheduled until at least ${dt.toFormat('h a')} or later`;
        } catch (e) {
            return '';
        }
    }

    public get cancellationThresholdHint(): string {
        try {
            let now = DateTime.local();
            now = now.plus({days: this.setting.cancellationThreshold});
            return `Example: Today is the last day you can cancel a booking for ${now.toFormat('MM/dd/yyyy')}`;
        } catch (e) {
            return '';
        }
    }

    public get acceptEmailThreshold(): string {
        try {
            return `The booking confirmed email will be sent after ${this.setting.acceptEmailThreshold} minutes, to allow for a vendor to cancel if need be.`;
        } catch (e) {
            return '';
        }
    }

    public get checkInBufferHint(): string {
        try {
            return `A pro can check in/out within ${this.setting.checkInBuffer} minutes of the beginning/end of a booking, you will be alerted if this time passes without a check in/out.`;
        } catch (e) {
            return '';
        }
    }

    private get searchQuery(): any {
        return nil(this.search, true) ? undefined : {email: {$search: this.search.toString()}};

    }
    private onEdit(u) {
        console.log(u);
    }
    public loading = true;
    public savedMessage = false;
    public setting: any = {};
    public categories: any[] = [];
    public categoryOrder: any[] = [];
    public search = '';
    public selectedRole = '';
    public rolesFor = {
        admin: [],
        vendor: [],
    };
    private allRoles = ['admin', 'vendor'];

    private headers = [
        {
            text: 'Email',
            value: 'email',
            sortable: true,
        },
        {
            text: 'Roles',
            value: 'roles',
            sortable: false,
        },
        /*{
            text:"Actions",
            value:"",
            sortable:false,
        }*/
    ];

    @Watch('search')
    public onSearchChanged(value: string, oldValue: string) {
        (this.$refs.userTable as any).refresh(true);
    }
    @Watch('selectedRole')
    public onSelectedRoleChanged(value: string, oldValue: string) {
        (this.$refs.userTable as any).refresh(true);
    }

    public mounted() {
        this.loadSettings();
        this.getCategories();
    }
    public async getCategories() {
        const cats = await FeathersVuexFindAll(this.$FeathersVuex.Category, {query: {$sort: {sort: 1}}});
        for (const category of cats) {
            category.image = [`/img/categories/${category._id}.jpeg`, `/img/categories/${category._id}.jpg`];
        }
        this.categories = cats;
    }
    public async loadSettings() {
        this.loading = true;
        this.setting = await getStoreSettings(this.$FeathersVuex.Setting);
        this.loading = false;
    }

    public async categoryOrderUpdated() {
        this.loading = true;
        try {
            for (let i = 0; i < this.categories.length; i++) {
                this.categories[i].sort = i;
                await this.categories[i].save();
            }
        } catch (e) {
            console.log('error encountered');
            console.log(e.message);
        }
        this.loading = false;
    }

    public async saveSettings(showSnack = true) {
        this.loading = true;
        const newSettings = Object.assign({}, this.setting);
        delete (newSettings._id);
        delete (newSettings._createdAt);
        delete (newSettings.__v);
        delete (newSettings.__updatedAt);
        delete (newSettings.__updatedAt);

        console.log(newSettings);
        await this.setting.patch(newSettings);
        this.loading = false;
        if (showSnack) {
            this.savedMessage = true;
        }
    }
    private isChecked(role, item) {
        if (nil(item.roles)) { return false; }
        return item.roles.indexOf(role) > -1;
    }
    private async rolesChanged(item, role, enabled) {
        const token = this.$store.state.auth.accessToken;
        let roles = nil(item.roles) ? [] : parseify(item.roles);
        if (enabled && roles.indexOf(role) === -1) {
            roles.push(role);
        } else if (!enabled && roles.indexOf(role) > -1) {
            roles = roles.filter((x) => x !== role);
        }
        await axiosInstance.patch(`/users/${item._id}`, {roles}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        (this.$refs.userTable as any).refresh(true);
        this.savedMessage = true;
    }

    private onQuery() {
        return {
            ...this.searchQuery,
        };
    }

}
